import { FC } from 'react';

export const CartIcon: FC = () => (
  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" role="presentation" width={20} height={20}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0,0v2h2l3.6,7.6L4.2,12C4.1,12.3,4,12.6,4,13c0,1.1,0.9,2,2,2h12v-2H6.4c-0.1,0-0.2-0.1-0.2-0.2l0-0.1L7.1,11h7.5c0.8,0,1.4-0.4,1.7-1l3.6-6.5C20,3.3,20,3.2,20,3c0-0.5-0.5-1-1-1H4.2L3.3,0H0z M6,16c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S7.1,16,6,16z M14,18c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S14,19.1,14,18z"
    />
  </svg>
);
